import "./App.css";
import Button from "react-bootstrap/Button";
import { Card, Col, Container, Image, Row } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import imgA from "./assets/Images/a.png";
import imgB from "./assets/Images/b.png";
import imgC from "./assets/Images/c.png";
import imgD from "./assets/Images/d.jpg";
import qrimage from "./assets/Images/QR-Code.png";

import logo from "./assets/Images/Logo.png";

function App() {
  return (
    <div className="App">
      <div className="text-center m-5">
        <Card.Title>&#60; FRONTENDTHEOREM &#62;</Card.Title>
        <Card.Text>
          Different Frontend Mentor UI Design Challenges and Code Solution{" "}
        </Card.Text>
        <a
          href="https://github.com/enggsuraj/frontendtheorem"
          target="_blank"
          without
          rel="noreferrer"
        >
          <Button variant="dark">GITHUB REPOSITORIES</Button>
        </a>
      </div>
      <div className="main">
        <Container>
          <Row>
            <Col sm={12}>
              {" "}
              <Row className="middle">
                <Col xs={12} sm={4}>
                  <Card className="card">
                    <Card.Img variant="top" src={imgA} />
                    <Card.Body>
                      <Card.Title>Social Media</Card.Title>
                      <Card.Text>
                        Social Media stats dashboard UI Design with light and
                        dark mode.
                      </Card.Text>
                      <a
                        href="https://github.com/enggsuraj/frontendtheorem/tree/main/socialmedia"
                        target="_blank"
                        without
                        rel="noreferrer"
                      >
                        <Button className="mr-1" variant="dark">
                          Code
                        </Button>
                      </a>
                      <a
                        href="https://enggsuraj.github.io/frontendtheorem/socialmedia/"
                        target="_blank"
                        without
                        rel="noreferrer"
                      >
                        <Button variant="dark">Live</Button>
                      </a>
                    </Card.Body>
                  </Card>
                </Col>
                <Col xs={12} sm={4}>
                  <Card className="card">
                    <Card.Img variant="top" src={imgB} />
                    <Card.Body>
                      <Card.Title>Testimonial Page</Card.Title>
                      <Card.Text>
                        Display user tstimonial data with slanted height and
                        star ratings.
                      </Card.Text>
                      <a
                        href="https://github.com/enggsuraj/frontendtheorem/tree/main/socialproof"
                        target="_blank"
                        without
                        rel="noreferrer"
                      >
                        <Button className="mr-1" variant="dark">
                          Code
                        </Button>
                      </a>
                      <a
                        href="https://enggsuraj.github.io/frontendtheorem/socialproof/"
                        target="_blank"
                        without
                        rel="noreferrer"
                      >
                        <Button variant="dark">Live</Button>
                      </a>
                    </Card.Body>
                  </Card>
                </Col>
                <Col xs={12} sm={4}>
                  <Card className="card">
                    <Card.Img variant="top" src={imgC} />
                    <Card.Body>
                      <Card.Title>Profile Card</Card.Title>
                      <Card.Text>
                        Design profile card displaying github stats, circular
                        design as background.
                      </Card.Text>
                      <a
                        href="https://github.com/enggsuraj/frontendtheorem/tree/main/profilecard"
                        target="_blank"
                        without
                        rel="noreferrer"
                      >
                        <Button className="mr-1" variant="dark">
                          Code
                        </Button>
                      </a>
                      <a
                        href="https://enggsuraj.github.io/frontendtheorem/profilecard/"
                        target="_blank"
                        without
                        rel="noreferrer"
                      >
                        <Button variant="dark">Live</Button>
                      </a>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <br />
        <Container>
          <Row>
            <Col sm={12}>
              {" "}
              <Row className="middle">
                <Col xs={12} sm={4}>
                  <Card className="card">
                    <Card.Img variant="top" src={qrimage} />
                    <Card.Body>
                      <Card.Title>Profile Card</Card.Title>
                      <Card.Text>
                        Design profile card displaying github stats, circular
                        design as background.
                      </Card.Text>
                      <a
                        href="https://github.com/enggsuraj/frontendtheorem/tree/main/qr-code"
                        target="_blank"
                        without
                        rel="noreferrer"
                      >
                        <Button className="mr-1" variant="dark">
                          Code
                        </Button>
                      </a>
                      <a
                        href="https://enggsuraj.github.io/frontendtheorem/qr-code/"
                        target="_blank"
                        without
                        rel="noreferrer"
                      >
                        <Button variant="dark">Live</Button>
                      </a>
                    </Card.Body>
                  </Card>
                </Col>
                <Col xs={12} sm={4}>
                  <Card className="card">
                    <Card.Img variant="top" src={imgD} />

                    <Card.Body>
                      <Card.Title>Project Tracker</Card.Title>
                      <Card.Text>
                        Project tracking app website design showcase with
                        responsiveness.
                      </Card.Text>
                      <a
                        href="https://github.com/enggsuraj/frontendtheorem/tree/main/project-tracking"
                        target="_blank"
                        without
                        rel="noreferrer"
                      >
                        <Button className="mr-1" variant="dark">
                          Code
                        </Button>
                      </a>
                      <a
                        href="https://enggsuraj.github.io/frontendtheorem/project-tracking/"
                        target="_blank"
                        without
                        rel="noreferrer"
                      >
                        <Button variant="dark">Live</Button>
                      </a>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>

        <footer>
          <div className="custom-shape-divider-bottom-1617824085">
            <svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
            >
              <path
                d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
                opacity=".25"
                className="shape-fill"
              ></path>
              <path
                d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
                opacity=".5"
                className="shape-fill"
              ></path>
              <path
                d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
                className="shape-fill"
              ></path>
            </svg>
          </div>
        </footer>
      </div>

      <div className="bottom">
        <img src={logo} alt="logo"></img>
        <p>blogtheorem.com</p>
      </div>
    </div>
  );
}

export default App;
